export default __webpack_public_path__ + "static/media/capres.0ee1930d.jpg";